<template>
  <Dialog
    v-model:visible="isVisible"
    :modal="true"
    :closable="true"
    :dismissable-mask="true"
    class="content-dialog"
  >
    <template #header>
      <div class="content-header">
        <h3>{{ $t('dialog.deletebarcode.title') }}</h3>
      </div>
    </template>
    <div class="confirmation-content col">
      <span>{{ $t('dialog.deletebarcode.content') }}</span><br><br>
    </div>
    <template #footer>
      <Button
        :label="$t('action.cancel')"
        icon="pi pi-times"
        class="p-button-rounded p-button-outlined p-button-secondary"
        @click="close"
      />
      <Button
        :label="$t('action.confirm')"
        icon="pi pi-check"
        class="p-button-rounded p-button-outlined"
        @click="deleteBarcode()"
      />
    </template>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import Button from "primevue/button";

export default {
  name: 'BarcodeDeleteDialog',
  components: {Dialog, Button},
  props: {
    barcode: {
      type: Object,
      default: null
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:visible', 'delete'],
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    }
  },
  methods: {
    close(){
      this.isVisible = false;
    },
    async deleteBarcode() {
      await this.$barcodeService.delete(this.barcode.id);
      this.$emit('delete');
      this.close();
    }
  }
}
</script>
